import {useCallback} from 'react';
import {Location} from 'react-router';

type State = {
  isNewDocument?: boolean;
  isDeletedDocument?: boolean;
  isSubmitForSignature: boolean;
  isResendingDocument?: boolean;
};

type BlockerFunction = (args: {currentLocation: Location<State>; nextLocation: Location<State>}) => boolean;

export const useShouldBlockNavigation = (hasUnsavedChanges: boolean) => {
  return useCallback<BlockerFunction>(
    ({currentLocation, nextLocation}) => {
      return (
        hasUnsavedChanges &&
        !nextLocation.state?.isNewDocument &&
        !nextLocation.state?.isDeletedDocument &&
        !currentLocation.state?.isResendingDocument &&
        !nextLocation.state?.isSubmitForSignature &&
        currentLocation.pathname !== nextLocation.pathname
      );
    },
    [hasUnsavedChanges],
  );
};
